// Predefined mentor expertise and industry taxonomies
export const expertiseCategories = [
  {
    id: "marketing_growth",
    title: "Marketing & Growth",
    tags: [
      "Digital Marketing",
      "Performance Marketing",
      "Growth Hacking",
      "SEO",
      "SEM / Google Ads",
      "Social Media Strategy",
      "Influencer Marketing",
      "Brand Strategy",
      "Content Marketing",
      "Community Building",
      "Marketing Automation",
      "Email Marketing",
      "Funnel Optimization",
      "Go-to-Market (GTM) Strategy",
      "PR & Communications",
      "Viral Marketing",
      "Customer Acquisition",
      "Customer Retention",
      "Event Marketing",
    ],
  },
  {
    id: "technology_engineering",
    title: "Technology & Engineering",
    tags: [
      "Software Engineering",
      "Full-Stack Development",
      "Frontend Development",
      "Backend Development",
      "Mobile App Development",
      "Cloud Computing",
      "DevOps",
      "Cybersecurity",
      "AI / Machine Learning",
      "Data Science",
      "Data Engineering",
      "Blockchain",
      "IoT (Internet of Things)",
      "AR/VR Development",
      "QA & Testing",
      "Product Architecture",
      "Databases & Storage Systems",
      "System Scalability",
      "API Design",
    ],
  },
  {
    id: "product_management",
    title: "Product Management",
    tags: [
      "Product Strategy",
      "Product Roadmap Creation",
      "User Experience (UX)",
      "User Interface (UI)",
      "Prototyping",
      "Wireframing",
      "Customer Discovery",
      "Design Thinking",
      "Agile Product Development",
      "Sprint Planning",
      "Feature Prioritization",
      "Product Analytics",
      "A/B Testing",
      "User Research",
      "Product Monetization",
      "Product Lifecycle Management",
    ],
  },
  {
    id: "sales_bd",
    title: "Sales & Business Development",
    tags: [
      "B2B Sales",
      "B2C Sales",
      "Account Management",
      "Lead Generation",
      "Sales Funnels",
      "Sales Operations",
      "CRM Management",
      "Negotiation",
      "Strategic Partnerships",
      "Channel Sales",
      "Key Account Acquisition",
      "Sales Forecasting",
      "Sales Pitch Development",
    ],
  },
  {
    id: "finance_fundraising",
    title: "Finance & Fundraising",
    tags: [
      "Financial Modeling",
      "Budgeting & Forecasting",
      "Business Valuation",
      "Investor Readiness",
      "Pitch Deck Review",
      "Fundraising Strategy",
      "Grants & Government Funding",
      "Venture Capital Strategy",
      "Angel Investment Strategy",
      "Cap Table Management",
      "Revenue Model Design",
      "Unit Economics",
      "Cash Flow Management",
    ],
  },
  {
    id: "legal_compliance",
    title: "Legal & Compliance",
    tags: [
      "Startup Legal Basics",
      "Contracts & Agreements",
      "IP Protection (Patents, Trademarks, Copyrights)",
      "Business Registration & Structure",
      "Regulatory Compliance",
      "Data Privacy (GDPR etc.)",
      "HR & Employment Law",
      "International Business Compliance",
      "Procurement & Vendor Contracts",
    ],
  },
  {
    id: "operations_scaling",
    title: "Operations & Scaling",
    tags: [
      "Operations Strategy",
      "Process Optimization",
      "Lean Operations",
      "OKRs & KPIs",
      "Supply Chain Management",
      "Inventory Management",
      "Project Management",
      "Talent Strategy",
      "Hiring Processes",
      "Team Building",
      "Remote Team Operations",
      "Risk Management",
      "Vendor Management",
    ],
  },
  {
    id: "leadership_soft",
    title: "Leadership & Soft Skills",
    tags: [
      "Leadership Coaching",
      "Communication Skills",
      "Time Management",
      "Conflict Resolution",
      "Decision Making",
      "Problem Solving",
      "Founder Psychology",
      "Negotiation",
      "Team Motivation",
      "Public Speaking",
      "Storytelling",
      "Emotional Intelligence",
    ],
  },
  {
    id: "industry_specific",
    title: "Industry-Specific Mentoring",
    tags: [
      "SaaS / Software",
      "SaaS Sales",
      "Subscription Models",
      "API Platforms",
      "E-commerce",
      "Marketplace Management",
      "Logistics Optimization",
      "D2C Growth",
      "HealthTech",
      "Digital Health Compliance",
      "Clinical Workflow Integration",
      "Medical Device Strategy",
      "FinTech",
      "Payments",
      "Lending Platforms",
      "Banking Integrations",
      "RegTech",
      "EdTech",
      "Learning Experience (LXP)",
      "Curriculum Development",
      "AgriTech",
      "Farm Supply Chain",
      "Agriculture IoT",
      "FoodTech",
      "Cloud Kitchens",
      "F&B Supply Chain",
      "Manufacturing",
      "Industry 4.0",
      "Automation",
      "CleanTech",
      "Renewable Energy",
      "Sustainability Strategy",
    ],
  },
  {
    id: "strategy_planning",
    title: "Strategy / Business Planning",
    tags: [
      "Business Strategy",
      "Market Research",
      "Competitive Analysis",
      "Business Model Design",
      "Pricing Strategy",
      "International Expansion",
      "Market Entry Strategy",
      "Unit Economics Optimization",
      "Scenario Planning",
      "Go-to-Market Strategy",
    ],
  },
  {
    id: "hr_people",
    title: "HR, Culture & People Development",
    tags: [
      "Organizational Culture",
      "HR Strategy",
      "Performance Management",
      "Training & Development",
      "Compensation & Benefits",
      "Employee Engagement",
      "Talent Retention",
      "Leadership Training",
    ],
  },
];

export const industryRoles = [
  "Product Manager",
  "Advisor",
  "CTO",
  "Consultant",
  "Founder",
  "Operations Lead",
  "Engineer",
  "Data / Analytics",
];

export const industryDetailOptions = [
  {
    id: "saas",
    label: "SaaS (Software as a Service)",
    domains: [
      "Subscription Models",
      "API Platforms",
      "B2B SaaS",
      "Multi-tenant Architecture",
      "Product Led Growth (PLG)",
      "Microservices",
      "DevOps",
      "Customer Success",
      "Churn Reduction",
      "Onboarding Experiences",
      "Usage Analytics",
      "Integrations (Zapier, Slack, HubSpot)",
    ],
  },
  {
    id: "fintech",
    label: "FinTech",
    domains: [
      "Payments",
      "UPI / Banking Integrations",
      "Wallet Systems",
      "Lending Platforms",
      "BNPL",
      "KYC / AML",
      "Digital Banking",
      "Core Banking Systems",
      "RegTech",
      "Cryptocurrency",
      "Investment Platforms",
      "InsuranceTech (InsurTech)",
      "Fraud Detection",
      "Credit Scoring Models",
    ],
  },
  {
    id: "healthtech",
    label: "HealthTech",
    domains: [
      "Electronic Health Records (EHR)",
      "Telemedicine",
      "Appointment Management",
      "Clinical Workflows",
      "HIPAA / Compliance",
      "Diagnostics",
      "Medical Devices",
      "Health Analytics",
      "Pharmacy Supply Chain",
      "Remote Patient Monitoring",
      "Hospital Information Systems",
    ],
  },
  {
    id: "edtech",
    label: "EdTech",
    domains: [
      "Learning Management Systems (LMS)",
      "Learning Experience Platforms (LXP)",
      "Course Authoring",
      "Adaptive Learning",
      "Gamified Learning",
      "Virtual Classrooms",
      "Assessment Engines",
      "Student Data Analytics",
      "Curriculum Design",
      "K–12 EdTech",
      "Corporate Learning",
    ],
  },
  {
    id: "ecommerce",
    label: "E-commerce",
    domains: [
      "Marketplace Management",
      "Catalog Management",
      "D2C Brands",
      "Logistics & Delivery Systems",
      "Warehouse Management",
      "Returns & Replacement",
      "Product Pricing & Discount Engines",
      "Inventory Control",
      "Payment Integrations",
      "Subscription Commerce",
      "Cross-border Commerce",
    ],
  },
  {
    id: "foodtech",
    label: "FoodTech",
    domains: [
      "Cloud Kitchens",
      "Aggregator Integrations (Zomato/Swiggy)",
      "Restaurant POS Systems",
      "Food Delivery Optimization",
      "F&B Supply Chain",
      "Hygiene Compliance",
      "Menu Engineering",
    ],
  },
  {
    id: "agritech",
    label: "AgriTech",
    domains: [
      "Farm Management Systems",
      "Agri Input Supply Chain",
      "Smart Irrigation / IoT",
      "Soil Health Analytics",
      "Crop Monitoring",
      "Farmer Marketplaces",
      "Weather Data Integrations",
      "Post-harvest Management",
    ],
  },
  {
    id: "cleantech",
    label: "CleanTech / Sustainability",
    domains: [
      "Renewable Energy",
      "Waste Management",
      "Circular Economy",
      "Carbon Accounting",
      "ESG Reporting",
      "Green Supply Chain",
      "Climate Tech Solutions",
    ],
  },
  {
    id: "logistics",
    label: "Logistics & Supply Chain",
    domains: [
      "Route Optimization",
      "Fleet Management",
      "3PL Integrations",
      "Warehouse Automation",
      "Demand Forecasting",
      "Procurement Systems",
      "Inventory Planning",
      "SCOR Model Applications",
    ],
  },
  {
    id: "manufacturing",
    label: "Manufacturing & Industrial",
    domains: [
      "Industry 4.0",
      "Factory Automation",
      "Robotics",
      "MES (Manufacturing Execution Systems)",
      "Production Planning",
      "Quality Control",
      "Lean Manufacturing",
      "Industrial IoT",
    ],
  },
  {
    id: "travel",
    label: "Travel & Hospitality",
    domains: [
      "Booking Systems",
      "Hotel PMS",
      "Dynamic Pricing",
      "Tour Management",
      "Travel Aggregator APIs",
      "Guest Experience Systems",
    ],
  },
  {
    id: "proptech",
    label: "Real Estate / PropTech",
    domains: [
      "Property Listing Platforms",
      "Real Estate Analytics",
      "Smart Buildings",
      "Tenant Management",
      "Rental Management Systems",
      "Property Valuation",
      "Facility Management",
    ],
  },
  {
    id: "mobility",
    label: "Mobility / EV",
    domains: [
      "EV Charging Infrastructure",
      "Ride-hailing Solutions",
      "Vehicle Tracking Systems",
      "Shared Mobility",
      "Battery Management Systems",
    ],
  },
  {
    id: "media",
    label: "Media & Entertainment",
    domains: [
      "OTT Platforms",
      "Content Distribution",
      "Creator Tools",
      "Rights & Licensing",
      "Streaming Analytics",
      "Production Workflows",
    ],
  },
  {
    id: "hrtech",
    label: "HRTech",
    domains: [
      "Recruitment Platforms",
      "ATS (Applicant Tracking Systems)",
      "Payroll / HRMS",
      "Employee Engagement Tools",
      "Workforce Analytics",
      "Performance Management",
    ],
  },
  {
    id: "retail",
    label: "Retail & Offline Commerce",
    domains: [
      "POS Systems",
      "Retail Analytics",
      "Franchise Management",
      "Merchandising",
      "Store Operations",
      "Customer Loyalty Systems",
    ],
  },
];

export const industryTaxonomy = industryDetailOptions.map(({ id, label }) => ({ id, label }));

